/** Tags: TagInput, TagPage, tag chips (`features/tags/*`). */
export const tags = {
  'tags.input.placeholder': 'Find or create a tag…',
  'tags.page.empty': 'No pages carry this tag.',

  // TagInput
  'tags.toast.invalidName': 'A tag needs a name of 1–64 characters.',
  'tags.addTag': 'Add a tag',
  'tags.empty.none': 'No tags yet.',
  'tags.empty.alreadyOn': 'Already on this page.',
  // Split around the name so it can render medium-weight inside the typographic quotes.
  'tags.createTagBefore': 'Create tag “',
  'tags.createTagAfter': '”',
  'tags.removeTag': 'Remove tag {name}',

  // TagView
  'tags.loadError': 'Couldn’t load this tag.',
  'tags.fallbackTitle': 'Tag',
  'tags.pageCount.one': '{count} page',
  'tags.pageCount.other': '{count} pages',

  // TagsSection
  'tags.section.heading': 'Tags',
  'tags.section.empty': 'No tags yet. Add one from a page’s header.',
  'tags.renameAria': 'Rename {name}',
  'tags.deleteAria': 'Delete tag {name}',
  'tags.deleteTag': 'Delete tag',
  'tags.confirmRemove.one': 'Remove the tag “{name}” from {count} page?',
  'tags.confirmRemove.other': 'Remove the tag “{name}” from {count} pages?',
  'tags.confirmRemove.description1': 'The pages are not deleted.',
  'tags.confirmRemove.description2': 'Only the tag is removed from them.',
  'tags.removeTagAction': 'Remove tag',
  'tags.toast.removed': 'Removed the tag “{name}”.',

  // useTags.ts toasts
  'tags.toast.renameError': "Couldn't rename the tag.",
  'tags.toast.deleteError': "Couldn't delete the tag.",

  // Outbox entry labels
  'tags.fallbackLabel': 'tag',
  'tags.assignLabel': 'tags',
} as const;
